import { render } from "./BackgroundAnimation.vue?vue&type=template&id=153774b2&scoped=true"
const script = {}

import "./BackgroundAnimation.vue?vue&type=style&index=0&id=153774b2&scoped=true&lang=scss"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153774b2"]])

export default __exports__